/**
 * Neo Gallery - Alpine.js Component
 * Lightbox with keyboard navigation, touch support
 */

if (!window.Eurus.loadedScript.has('neo-gallery.js')) {
  window.Eurus.loadedScript.add('neo-gallery.js');

  document.addEventListener('alpine:init', () => {
    Alpine.data('xNeoGallery', (config) => ({
      sectionId: config.sectionId,
      enableLightbox: config.enableLightbox || false,
      totalItems: config.totalItems || 0,

      // Lightbox state
      lightboxOpen: false,
      currentIndex: 0,
      currentImage: '',
      currentAlt: '',
      images: [],

      init() {
        if (this.enableLightbox) {
          this.collectImages();
        }
      },

      /**
       * Collect all gallery images for lightbox navigation
       */
      collectImages() {
        const container = this.$el;
        const imageButtons = container.querySelectorAll('.neo-gallery-card__link[data-src]');

        this.images = Array.from(imageButtons).map((btn, index) => ({
          src: btn.dataset.src,
          alt: btn.dataset.alt || '',
          index: index
        }));

        this.totalItems = this.images.length;
      },

      /**
       * Open lightbox at specific index
       */
      openLightbox(index) {
        if (!this.enableLightbox || this.images.length === 0) return;

        this.currentIndex = index;
        this.updateCurrentImage();
        this.lightboxOpen = true;

        // Prevent body scroll
        document.body.style.overflow = 'hidden';

        // Focus trap
        this.$nextTick(() => {
          const closeBtn = document.querySelector('.neo-gallery-lightbox__close');
          if (closeBtn) closeBtn.focus();
        });
      },

      /**
       * Close lightbox
       */
      closeLightbox() {
        this.lightboxOpen = false;
        document.body.style.overflow = '';

        // Return focus to the triggering element
        const triggerBtn = this.$el.querySelector(`[data-index="${this.currentIndex}"] .neo-gallery-card__link`);
        if (triggerBtn) triggerBtn.focus();
      },

      /**
       * Navigate to previous image
       */
      prevImage() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updateCurrentImage();
        }
      },

      /**
       * Navigate to next image
       */
      nextImage() {
        if (this.currentIndex < this.totalItems - 1) {
          this.currentIndex++;
          this.updateCurrentImage();
        }
      },

      /**
       * Update current image based on index
       */
      updateCurrentImage() {
        const image = this.images[this.currentIndex];
        if (image) {
          this.currentImage = image.src;
          this.currentAlt = image.alt;
        }
      },

      /**
       * Handle swipe gestures for mobile
       */
      handleSwipe(direction) {
        if (direction === 'left') {
          this.nextImage();
        } else if (direction === 'right') {
          this.prevImage();
        }
      }
    }));
  });

  // Touch swipe support for lightbox
  document.addEventListener('DOMContentLoaded', () => {
    let touchStartX = 0;
    let touchEndX = 0;

    document.addEventListener('touchstart', (e) => {
      if (e.target.closest('.neo-gallery-lightbox__content')) {
        touchStartX = e.changedTouches[0].screenX;
      }
    }, { passive: true });

    document.addEventListener('touchend', (e) => {
      if (e.target.closest('.neo-gallery-lightbox__content')) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipeGesture();
      }
    }, { passive: true });

    function handleSwipeGesture() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        // Find the Alpine component
        const galleryEl = document.querySelector('[x-data*="xNeoGallery"]');
        if (galleryEl && galleryEl._x_dataStack) {
          const component = galleryEl._x_dataStack[0];
          if (component && component.lightboxOpen) {
            if (diff > 0) {
              component.nextImage();
            } else {
              component.prevImage();
            }
          }
        }
      }
    }
  });
}
